export enum PaymentOptionsSelectionDataHooks {
  PAYMENT_OPTIONS_SELECTION = 'payment-options-selection',
  PAYMENT_OPTIONS_SELECTION_LABEL = 'payment-options-selector-label',
}
